const STORAGE_KEY = 'chainsight_etag_store';

const readStore = () => {
  if (typeof sessionStorage === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeStore = (store) => {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // ignore quota errors
  }
};

export const getEtagEntry = (key) => {
  const store = readStore();
  return store[key] ?? null;
};

export const setEtagEntry = (key, { etag, syncToken } = {}) => {
  const store = readStore();
  store[key] = {
    etag: etag ?? store[key]?.etag ?? '',
    syncToken: syncToken ?? store[key]?.syncToken ?? '',
    cachedAt: Date.now(),
  };
  writeStore(store);
  return store[key];
};

export const clearEtagEntry = (key) => {
  const store = readStore();
  delete store[key];
  writeStore(store);
};

export const clearEtagByPrefix = (prefix) => {
  const store = readStore();
  Object.keys(store).forEach((key) => {
    if (key.startsWith(prefix)) delete store[key];
  });
  writeStore(store);
};

export const etagKeyForUser = (resource, userId) => `${resource}:${userId}`;
